
export const VERSION = '5.4.23'; // Update this manually on each release

